window.addEventListener('DOMContentLoaded', (event) => {
    let toggler = document.querySelector('.toggle');
    let services = document.querySelector('.main-services-list');

    function toggleServices () {
        toggler.classList.toggle('open')
        services.classList.toggle('open')
    }

    if (toggler) {
        toggler.addEventListener('click', toggleServices)
    }
});
